<div class="modal" tabindex="-1" role="dialog" id="modAddPartner" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="text-success text-center font-weight-bold">Partenaire ajout&#233;</span>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
    </div>
  </div>
</div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="modAddUser" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="text-success text-center font-weight-bold">{{message}}</span></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-2 row">
  @if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
    <div class="col-3 ">
      @if (!isAddUser) {
        <button class="btn btn-success mt-2 mb-2 " (click)="changeScreen()">Ajouter
        utilisateur</button>
      }
    </div>
  }

  @if (!isAddUser&&this.connectedUser?.partner?.type =='SYSTEM') {
    <form class="mb-2 col-4 d-flex flex-row align-items-center flex-wrap"
      (submit)="onChangePartner()"
      [formGroup]="formPartner">
      <div class="form-group form-floating">
        <select formControlName="partner" class="form-select my-1 me-sm-2 w-auto" (change)="loadPartners()">
          @for (pp of partners; track $index) {
            <option value="{{pp.id}}">{{pp.name}}</option>
          }
        </select>
        <label>Choisir un partenaire</label>
      </div>
      <button class="btn btn-success rounded" type="submit" style="display: inline-block;"
      [disabled]="!this.formPartner.valid">Valider</button>
    </form>
  }
</div>
@if (isAddUser) {
  <button class="btn btn-success mb-2" (click)="changeScreen()">Liste
  utilisateurs</button>
}
@if (!isAddUser) {
  <div id="listPartners" class="row">
    <table class="table table-bordered table-hover table-striped text-center">
      <thead class="table-success">
        <tr>
          <th>Nom</th>
          <th>Profil</th>
          <th>T&#233;l&#233;phone</th>
          <th>Identifiant</th>
          @if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (user of listUsers?.content | paginate : {id:'tabUsers',itemsPerPage: pageConfig.itemsPerPage, currentPage: pageConfig.currentPage, totalItems: pageConfig.totalItems}; track $index) {
          <tr>
            <td>{{user.firstName}} {{user.lastName}}</td>
            <td>{{user.role.libelle}}</td>
            <td>{{user.phone}}</td>
            <td>{{user.username}}</td>
            @if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
              <td>
                <div class="d-flex d-flex-row align-items-start justify-content-center">
                  <button class="btn btn-warning ml-auto mr-4 p-2" (click)="setUserDetails(user)">Modifier</button>
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
      <div class="d-flex justify-content-center">
        <pagination-controls id="tabUsers" previousLabel="Precedent" 
        [maxSize]="7"
        [autoHide]="false"
        [directionLinks]="true"
        [responsive]="true" nextLabel="Suivant" (pageChange)="onNextPage($event)">
        </pagination-controls>
      </div>
    </table>
  </div>
}
@if (isAddUser) {
  <div class="container d-flex justify-content-center align-items-center" id="addParner">
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;"
      (ngSubmit)="onAddOrUpdateUser()" [formGroup]="userForm">
      <div class="mt-2 ml-2 mr-2 p-4 border rounded">
        <h2 class="mb-4">Informations utilisateur</h2>
        @if (currentUser?.id!=connectedUser?.id) {
          <div class="form-group form-floating">
            @if (currentUser?.id!=connectedUser?.id) {
              <select formControlName="idPartner" class="ml-2 mr-2 mt-2 form-select" (change)="getRoles()"
                >
                @for (partner of partners; track partner) {
                  <option value="{{partner.id}}">{{partner.name}}</option>
                }
              </select>
            }
            <label>Choisir le partenaire</label>
          </div>
        }
        @if (currentUser?.id==connectedUser?.id) {
          <div>
            <div class="form-group form-floating">
              <input class="text" value="{{connectedUser?.partner?.name}}" class="form-control" id="parterName"
                disabled>
              <label for="parterName">Nom du partenaire</label>
            </div>
            <input formControlName="idPartner" value="connectedUser?.partner?.id" type="hidden">
          </div>
        }
        <div class="form-group  form-floating">
          <input type="text" class="ml-2 mr-2 mt-2 form-control" id="firstName" formControlName="firstName"
            placeholder="Prénom">
          <label class="form-label ml-2 d-flex align-items-start" for="firstName">Pr&#233;nom</label>
        </div>
        <div class="form-group  form-floating">
          <input type="text" class="ml-2 mr-2 mt-2 form-control" id="lastName" formControlName="lastName"
            placeholder="Nom">
          <label class="form-label d-flex align-items-start" for="lastName">Nom</label>
        </div>
        <div class="form-group  form-floating">
          <input type="tel" class="ml-2 mr-2 mt-2 form-control" id="phone" formControlName="phone"
            placeholder="T&#233;l&#233;phone (ex 221 76 311 00 00)">
          <label class="form-label d-flex align-items-start" for="phone">T&#233;l&#233;phone (ex 221 76 311 00
          00)</label>
        </div>
        <div class="form-group  form-floating">
          <input type="email" class="ml-2 mr-2 mt-2 form-control" id="email" formControlName="email"
            placeholder="Entrer email">
          <label class="form-label d-flex align-items-start" for="email">Email</label>
        </div>
        <div class="form-group  form-floating">
          <select formControlName="role" class="ml-2 mr-2 mt-2 form-select" (change)="getRoles()">
            @for (role of roles; track role) {
              <option value="{{role.code}}">{{role.libelle}}</option>
            }
          </select>
          <label>Choisir le profil</label>
        </div>
      </div>
      <button type="submit" class="btn btn-success btn-block mt-3" [disabled]="!this.userForm.valid">Valider</button>
    </form>
  </div>
}
